"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DIRECTIONS = exports.translateCell = exports.getNeighborInt = exports.getNeighborBase32 = exports.getNeighborsInt = exports.getNeighborsBase32 = void 0;
var types_1 = require("./types");
var helpers_1 = require("./helpers");
var hashing_1 = require("./hashing");
var constants_1 = require("./constants");
/**
 * Calculates all neighbors' Base32 Geohashes.
 * @param hashBase32 Base32 string (Geohash version of Base32)
 * @returns A {@link Neighbors} with Base32 Geohashes starting from North
 */
function getNeighborsBase32(hashBase32) {
    var precision = hashBase32.length;
    var hashInt = (0, helpers_1.base32ToInt)(hashBase32);
    var neighborsInt = getNeighborsInt(hashInt, precision * constants_1.BASE32_BITS_PER_CHAR);
    var neighborsBase32Entries = Object.entries(neighborsInt).map(function (_a) {
        var direction = _a[0], neighborHashInt = _a[1];
        return [direction, (0, helpers_1.intToBase32)(neighborHashInt, precision)];
    });
    return Object.fromEntries(neighborsBase32Entries);
}
exports.getNeighborsBase32 = getNeighborsBase32;
/**
 * Calculates all neighbors' integer Geohashes.
 * @param hashInt Geohash integer
 * @param bitDepth Defines precision of encoding.
 * The bigger the value, the smaller the encoded cell.
 * Can be either even or odd. Must be between 1 and 52.
 * @returns A {@link Neighbors} with Geohash integers starting from North.
 */
function getNeighborsInt(hashInt, bitDepth) {
    if (bitDepth === void 0) { bitDepth = constants_1.MAX_BIT_DEPTH; }
    (0, helpers_1.assertBitDepthIsValid)(bitDepth);
    var neighborsIntEntries = Object.values(types_1.Direction).map(function (direction) { return [
        direction,
        getNeighborInt(hashInt, direction, bitDepth),
    ]; });
    return Object.fromEntries(neighborsIntEntries);
}
exports.getNeighborsInt = getNeighborsInt;
/**
 * Calculates neighbor's Geohash Base32 string.
 * @param hashBase32 Base32 string (Geohash version of Base32) whose neighbor should be found.
 * @param direction Specifies which neighbor should be found (e.g. northern, southwestern, etc.)
 * @returns Neighbor's Base32 Geohash.
 */
function getNeighborBase32(hashBase32, direction) {
    var precision = hashBase32.length;
    var hashInt = (0, helpers_1.base32ToInt)(hashBase32);
    var neighborHashInt = getNeighborInt(hashInt, direction, precision * constants_1.BASE32_BITS_PER_CHAR);
    return (0, helpers_1.intToBase32)(neighborHashInt, precision);
}
exports.getNeighborBase32 = getNeighborBase32;
/**
 * Calculates neighbor's Geohash integer.
 * @param hashInt Geohash integer whose neighbor should be found.
 * @param direction Specifies which neighbor should be found (e.g. northern, southwestern, etc.)
 * @param bitDepth Defines precision of encoding.
 * The bigger the value, the smaller the encoded cell.
 * Can be either even or odd. Must be between 1 and 52.
 * @returns Neighbor's Geohash integer.
 */
function getNeighborInt(hashInt, direction, bitDepth) {
    if (bitDepth === void 0) { bitDepth = constants_1.MAX_BIT_DEPTH; }
    (0, helpers_1.assertBitDepthIsValid)(bitDepth);
    var _a = exports.DIRECTIONS[direction], latMultiplier = _a[0], lngMultiplier = _a[1];
    return translateCell(hashInt, { lat: latMultiplier, lng: lngMultiplier }, bitDepth);
}
exports.getNeighborInt = getNeighborInt;
function translateCell(hashInt, translation, bitDepth) {
    var _a = (0, hashing_1.decodeInt)(hashInt, bitDepth), lat = _a.lat, lng = _a.lng, error = _a.error;
    return (0, hashing_1.encodeInt)(lat + translation.lat * error.lat * 2, lng + translation.lng * error.lng * 2, bitDepth);
}
exports.translateCell = translateCell;
exports.DIRECTIONS = (_a = {},
    _a[types_1.Direction.West] = [0, -1],
    _a[types_1.Direction.NorthWest] = [1, -1],
    _a[types_1.Direction.North] = [1, 0],
    _a[types_1.Direction.NorthEast] = [1, 1],
    _a[types_1.Direction.East] = [0, 1],
    _a[types_1.Direction.SouthEast] = [-1, 1],
    _a[types_1.Direction.South] = [-1, 0],
    _a[types_1.Direction.SouthWest] = [-1, -1],
    _a);
